var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[(!_vm.$route.meta.hideNavigation)?_c('MainNavbar'):_vm._e(),_c('main',{staticClass:"content-wrapper"},[_c('router-view')],1),(!_vm.$route.meta.hideNavigation)?_c('MainFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }